// DS3.5
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import InputErrorMessage from '@wix/da-ds/pkg/formControls/lego/InputErrorMessage';
import InputLabelText from '@wix/da-ds/pkg/formControls/lego/InputLabelText';
import InputLabelSubText from '@wix/da-ds/pkg/formControls/lego/InputLabelSubText';
import FormElement from '@wix/da-ds/pkg/formControls/layouts/FormElement';
import DropdownStateManager from '../../DropdownStateManager';
import noop from '../../../utils/noop';
import SelectFieldContent from './SelectFieldContent';
import s from './SelectField.scss';
const SelectField = (_param)=>{
    var { id, className, label, subLabel, isLabelHidden, isRequired, error, onSelect = noop, noBottomSpacing = true } = _param, rest = _object_without_properties(_param, [
        "id",
        "className",
        "label",
        "subLabel",
        "isLabelHidden",
        "isRequired",
        "error",
        "onSelect",
        "noBottomSpacing"
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, /*#__PURE__*/ React.createElement(FormElement, {
        inputId: id,
        label: /*#__PURE__*/ React.createElement(InputLabelText, {
            isRequired: isRequired,
            className: "label"
        }, label),
        subLabel: subLabel && /*#__PURE__*/ React.createElement(InputLabelSubText, {
            className: "sublabel"
        }, subLabel),
        isLabelHidden: isLabelHidden,
        noBottomSpacing: noBottomSpacing,
        details: error && /*#__PURE__*/ React.createElement(InputErrorMessage, {
            id: `${id}-error`
        }, error)
    }, /*#__PURE__*/ React.createElement(SelectFieldContent, _object_spread({
        id: id,
        onSelect: onSelect,
        required: isRequired,
        hasError: !!error
    }, rest))));
};
SelectField.displayName = 'SelectField';
const SelectFieldWithDropdownState = (props)=>/*#__PURE__*/ React.createElement(DropdownStateManager, null, /*#__PURE__*/ React.createElement(SelectField, props));
export default SelectFieldWithDropdownState;
